import { useParams } from 'react-router-dom';

import { useGetProductFullView } from 'hooks';

import { MEMBER_TYPE_RETAILER } from 'static/Constants';

import { useUserInfo } from 'hooks/auth/useUserInfo';

const useCheckSnapshotForRetailer = () => {
  const { id: productId } = useParams();

  const { productFull } = useGetProductFullView({
    productId,
  });

  const qaSpecDataHeader = null;

  let { userInfo } = useUserInfo();

  const checkSnapshot = () => {
    const isProductOwner = productFull?.ownerId === userInfo?.member?.id;

    const isRetailer =
      userInfo?.member?.memberType?.toLowerCase() ===
      MEMBER_TYPE_RETAILER.toLowerCase();

    const isSubmittedQaSpec =
      qaSpecDataHeader?.status?.toLowerCase() === 'submitted';

    return isRetailer && isProductOwner && isSubmittedQaSpec;
  };

  return checkSnapshot();
};

export default useCheckSnapshotForRetailer;
